/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {Registration} from './components/Registration'
/* import {ForgotPassword} from './components/ForgotPassword' */
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { Card, CardMedia, CardContent, Typography, TextField, Button, Link } from "@mui/material";
export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundColor: '#f4f4f4', // Add this line to set the background color
      }}
    >
     
        {/* <div>
         <div className=' bg-white rounded shadow-sm mx-auto' style={{ width: '75%', maxWidth: '90%', minHeight: '50vh'}}>
        <a href='#'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-1-dark.svg')} className='h-40px radius-10' />
           </a>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/registration' component={Registration} /> */}
          {/*  <Route path='/auth/forgot-password' component={ForgotPassword} />  */}
            {/* <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
        </div>
       */}

      <Card sx={{ maxWidth: '80%',maxHeight:'90%', margin: "0 auto", mt: 1}}>
      <a href='#'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-dhiraagu-02.svg')} className='h-40px radius-10' />
           </a>
      <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/registration' component={Registration} />
            <Redirect to='/auth/login' />
        </Switch>
      </Card>



      {/* <div className='d-flex flex-center flex-column-auto p-10' >
       
      </div> */}
      {/* end::Footer */}
    </div>
  )
}
